import Box from '@mui/material/Box';
import React from 'react';

import Icon from '@/assets/icons/sort-icon.svg?react';

interface Props {
  readonly className: string;
}

export const SortIcon: React.FC<Props> = (props: Props): React.ReactElement => {
  const { className } = props;

  return (
    <Box className={className} color="custom.LightGray" width={24} height={24}>
      <Icon fill="currentColor" />
    </Box>
  );
};
